import { getReceiptTemplateByHspId } from '../config';
import { dsmcReceiptHtml } from '../ui/receiptTemplate/dsmc';
import {
  hallymChuncheonReceiptHtml,
  hallymDongtanReceiptHtml,
  hallymGangnamReceiptHtml,
  hallymPyeongchonReceiptHtml,
} from '../ui/receiptTemplate/hallym';

const TEMPLATE_MAP = {
  dsmc: dsmcReceiptHtml,
  'hallym-chuncheon': hallymChuncheonReceiptHtml,
  'hallym-pyeongchon': hallymPyeongchonReceiptHtml,
  'hallym-dongtan': hallymDongtanReceiptHtml,
  'hallym-gangnam': hallymGangnamReceiptHtml,
};

export const getReceiptTemplate = (hspId) => {
  const templateKey = getReceiptTemplateByHspId(hspId);
  return TEMPLATE_MAP[templateKey] || TEMPLATE_MAP['dsmc'];
};
